import { observer } from 'mobx-react';
import { CompoundButton } from 'office-ui-fabric-react/lib/Button';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { logMountingPerformance } from 'owa-analytics';
import FilePickerAction from '../../store/schema/FilePickerAction';
import * as React from 'react';

export interface FilePickerActionsPanelButtonProps {
    action: FilePickerAction;
    actionLabel: string;
    actionDescription: string;
    buttonIcon: JSX.Element;
    isDisabled: boolean;
    onActionButtonClicked: (action: FilePickerAction) => void;
    shouldAutoFocus: boolean; // Used to set the focus on first available action when the panel initially renders.
}

const styles = require('./FilePickerActionsPanelButtonView.scss');

@observer
@logMountingPerformance('FilePickerActionsPanelButtonView')
export default class FilePickerActionsPanelButtonView extends React.Component<
    FilePickerActionsPanelButtonProps,
    {}
> {
    render() {
        const textButtonClassName = this.props.isDisabled
            ? styles.disabledActionTextButton
            : styles.actionTextButton;
        const className = this.props.isDisabled
            ? styles.disabledActionIconButton
            : styles.actionIconButton;
        const onClick = this.props.isDisabled
            ? () => null
            : () => this.props.onActionButtonClicked(this.props.action);

        const ariaProps: AriaProperties = {
            role: AriaRoles.button,
            label: `${this.props.actionLabel}, ${this.props.actionDescription}`,
        };

        return (
            <div className={styles.actionContainer}>
                <button
                    className={className}
                    disabled={this.props.isDisabled}
                    onClick={onClick}
                    autoFocus={this.props.shouldAutoFocus}
                    tabIndex={
                        this.props.isDisabled
                            ? -1
                            : 0 /* We should be able to tab to the icon if and only if it is clickable */
                    }
                    {...generateDomPropertiesForAria(ariaProps)}>
                    <div className={styles.iconContainer}>{this.props.buttonIcon}</div>
                </button>

                <CompoundButton
                    className={textButtonClassName}
                    description={this.props.actionDescription}
                    disabled={this.props.isDisabled}
                    ariaLabel={this.props.actionLabel}
                    onClick={() => {
                        this.props.onActionButtonClicked(this.props.action);
                    }}
                    tabIndex={-1}>
                    {this.props.actionLabel}
                </CompoundButton>
            </div>
        );
    }
}
